import * as types from './types';
import fetch from 'isomorphic-fetch';
import { default as config } from  '../constants';
import { clearState } from '../store/localStorage';

export function loadCalculatorsSuccess(budgets) {
	return { type: types.LOAD_CALCULATORS_SUCCESS, budgets }
}

export function loadCalculatorsFailure() {
	return { type: types.LOAD_CALCULATORS_FAILURE }
}

export function loadBudgetLineItemFailure() {
	return { type: types.LOAD_CALCULATORS_FAILURE }
}

export function loadBudgetLineItemSuccess(lineItem) {
	return { type: types.LOAD_BUDGET_LINE_ITEM_SUCCESS, lineItem }
}

export function resetCalculatorSuccess() {
	return { type: types.RESET_CALCULATOR_SUCCESS }
}

export function loadLineItem(id) {

}

export function loadBudgetContainers() {
	return function (dispatch) {
		return fetch('/wp-json/acf/v3/budget-calculator', { credentials: 'include', headers: config.HEADERS }).then((response) => {
			if (response.status >= 400) {
				dispatch(loadCalculatorsFailure())
			} else {
				response.json().then((obj) => {
					dispatch(loadCalculatorsSuccess(obj));
				});
			}
		}).catch(error => {
			throw (error);
		});
	}
}

export function resetCalculator() {
	return function(dispatch) {
		clearState();
		dispatch(resetCalculatorSuccess());
	}
}

export function loadBudgetLineItem(id) {
	return function (dispatch) {
		return fetch('/wp-json/acf/v3/budget-item/'+id, { credentials: 'include', headers: config.HEADERS }).then((response) => {
			if (response.status >= 400) {
				dispatch(loadBudgetLineItemFailure())
			} else {
				response.json().then((obj) => {
					dispatch(loadBudgetLineItemSuccess(obj));
				});
			}
		}).catch(error => {
			throw (error);
		});
	}
}



// WEBPACK FOOTER //
// ./src/actions/budgetActions.js